import { render, staticRenderFns } from "./ProductPageTheme0.vue?vue&type=template&id=bc348aca&scoped=true"
import script from "./ProductPageTheme0.vue?vue&type=script&lang=js"
export * from "./ProductPageTheme0.vue?vue&type=script&lang=js"
import style0 from "./ProductPageTheme0.vue?vue&type=style&index=0&id=bc348aca&prod&lang=css"
import style1 from "./ProductPageTheme0.vue?vue&type=style&index=1&id=bc348aca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc348aca",
  null
  
)

export default component.exports